import { render, staticRenderFns } from "./export-profiles-index.vue?vue&type=template&id=0ddb6c44&scoped=true&"
import script from "./export-profiles-index.vue?vue&type=script&lang=js&"
export * from "./export-profiles-index.vue?vue&type=script&lang=js&"
import style0 from "./export-profiles-index.vue?vue&type=style&index=0&id=0ddb6c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddb6c44",
  null
  
)

export default component.exports